module.exports = "<a href=\"/en/\"><img src=\"/images/header-2025en.jpg\" style=\"width: 100%\" alt=\"Global Alliance Conference\"/></a>\n<div class=\"row\">\n  <div class=\"col-xs-10 col-xs-offset-1\">\n    <nav class=\"navbar\">\n      <ul class=\"nav navbar-nav\">\n        <li><a href=\"en\">Invitation</a></li>\n        <li><a href=\"en/speakers\">Speakers</a></li>\n        <li><a href=\"en/intro\">About GA</a></li>\n        <!--<li><a href=\"en/registration\">신청서 작성하기</a></li>-->\n        <li><a href=\"ko\">한국어</a></li>\n      </ul>\n    </nav>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/en/header.html
// module id = 892
// module chunks = 1